/** ConditionNode — `condition.if` branching node. */
import type { ReactNode } from 'react';
import type { NodeProps } from 'reactflow';
import { NODE_TYPES } from '../../lib/agents';
import { BaseNode, type BaseNodeData } from './BaseNode';

export function ConditionNode(props: NodeProps<BaseNodeData>): ReactNode {
  return <BaseNode {...props} nodeType={NODE_TYPES.CONDITION_IF} />;
}
